<template>
  <div v-if="filterCourses(search, courses).length > 0">
    <h2 class="headline">
      Pending Courses
    </h2>
    <!-- Draft List -->
    <v-row class="holder">
      <v-col class="col-12" v-if="courses.length == 0 && loaded">
        <slot name="missing">
          <p class="title">
            There are no pending courses at this time. Wait for a draft to be
            published.
          </p>
        </slot>
        <slot name="notfound"></slot>
      </v-col>
      <v-col
        class="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3"
        v-for="item in filterCourses(search, courses)"
        v-bind:key="item.title"
      >
        <a-l-pendingcard
          :course="item"
          @edit="onEdit"
          @approve="toggleApprove"
          @reject="rejectCourse"
        >
        </a-l-pendingcard>
      </v-col>
    </v-row>
    <!-- Error Modal -->
    <a-confirm-modal :dialog="cannotApprove">
      <template slot="headline">
        Failed to Approve the Course
      </template>
      <template slot="body"
        ><p>
          At this time, this course cannot be approved. This could be because
          the writer withdrew it from "pending".<br />
          Refresh the page and try again. If the error persists, please reach
          out to support@arist.co.
        </p>
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="blue"
          dark
          @click="
            cannotApprove = false;
            onLoad();
          "
          >Dismiss and Refresh</v-btn
        >
      </template>
    </a-confirm-modal>
    <!-- End Error Modal -->
    <!-- Apprve Confirmation Modal -->
    <a-confirm-modal :dialog="showApproveConfirm">
      <template slot="headline">
        Approve "{{ approveName }}"
      </template>
      <template slot="body">
        This action is permanent. This will revoke writer access, making it so
        only publishers can make adjustments to content. This will also add
        further restrictions to editing content, removing the ability to add,
        rearrange, and remove "days". Only day content and course properties
        will be editable.
      </template>
      <template slot="actions">
        <v-btn color="grey" dark depressed @click="onApproveReject"
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn depressed color="blue" dark @click="onApproveConfirm"
          >Approve Course</v-btn
        >
      </template>
    </a-confirm-modal>
    <!-- End Apprve Confirmation Modal -->
  </div>
</template>
<style scoped>
.holder {
  padding-bottom: 100px;
}
</style>
<script>
import pendingCard from "./pendingcard";
import service from "@/services/index.js";
import confirm from "@/components/confirmation-modal";

export default {
  components: {
    "a-l-pendingcard": pendingCard,
    "a-confirm-modal": confirm
  },
  data: () => ({
    loaded: false,
    courses: [],
    show: false,
    toBePublished: null,
    showApproveConfirm: false,
    cannotApprove: false
  }),
  computed: {
    approveName() {
      if (!this.toBePublished) {
        return "";
      }
      return this.toBePublished.name || "None";
    }
  },
  props: {
    search: {
      type: String,
      default: () => ""
    }
  },
  methods: {
    filterCourses(title, source) {
      return source.filter(course =>
        String(course.name)
          .trim()
          .toLowerCase()
          .includes(
            String(title)
              .trim()
              .toLowerCase()
          )
      );
    },
    /**
     * Handles loading of the initial courses.
     */
    async onLoad() {
      try {
        this.$store.commit("setLoading", true);
        this.courses = await service.course.get({
          status: "pending",
          type: "publisher"
        });
        this.$store.commit("setLoading", false);
      } catch (err) {
        console.log("Pending", err);
        this.$store.commit("setLoading", false);
      }
      this.loaded = true;
      console.log(this.drafcoursests);
    },
    /**
     * Handles routing to the editor.
     */
    onEdit(course) {
      try {
        this.$ga.event({
          eventCategory: "dashboard-courses",
          eventAction: "pending-draft-edit",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.log(err);
      }
      this.$router.push({
        name: "coursebuilder-editor-published",
        params: { id: course._id }
      });
    },
    /**
     * Handles updating a course to not be approved.
     */
    async rejectCourse(course) {
      try {
        this.$store.commit("setLoading", true);
        await service.course.update({
          id: course._id,
          coursedoc: {
            pendingApproval: false
          },
          type: "publisher"
        });
        this.onLoad();
        this.$emit("update");
      } catch (err) {
        console.error(err);
      }
      this.$store.commit("setLoading", false);
      try {
        this.$ga.event({
          eventCategory: "dashboard-courses",
          eventAction: "pending-draft-reject",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * Handles approving a course.
     */
    async approveCourse(course) {
      try {
        this.$store.commit("setLoading", true);
        await service.course.publish({
          id: course._id
        });
        this.onLoad();
        this.$emit("update");
      } catch (err) {
        this.cannotApprove = true;
        console.error(err);
      }
      this.$store.commit("setLoading", false);
      try {
        this.$ga.event({
          eventCategory: "dashboard-courses",
          eventAction: "pending-draft-approve",
          eventLabel: "Dashboard"
        });
      } catch (err) {
        console.log(err);
      }
    },
    /**
     * Preps the modal that will ask if this course should be deleted or not.
     */
    toggleApprove(course) {
      // this.$store.commit("setLoading", true);
      this.toBePublished = course;
      this.showApproveConfirm = true;
    },
    async onApproveConfirm() {
      await this.approveCourse(this.toBePublished);
      this.onApproveReject();
    },
    onApproveReject() {
      this.toBePublished = null;
      this.showApproveConfirm = false;
    }
  },
  mounted() {
    this.onLoad();
  }
};
</script>

<style></style>
